import { CardData } from './card-data';
import type { Variant } from '../product/dto/variant';

export class GenericCardData extends CardData {
  protected override getGridSizeHelperForCapsules(variant: Variant): string | null {
    const n = variant?.packagedQuantity ?? 0;
    return `${n} Capsule`
      .pluralizer()
      .addRule({ isPlural: n > 1, useApostrophe: false, word: 'Capsule' })
      .pluralize();
  }
}
